import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Table, Drawer, Switch } from 'antd';
import dotProp from 'dot-prop-immutable';
import isEqual from 'lodash/isEqual';

import * as pageActions from '../../../../../data/redux/page_details/actions';
import * as teamMemberSettingActions from '../../../../../data/redux/team_member_setting_details/actions';

import { uniqueId, showMessage } from '../../../../../data/config/utils';
import { APP_PAGES, PERMISSIONS } from '../../../../../data/config/constants';
import { IconSuccess, IconHistory } from '../../../../../data/assets/icons';
import { IMG_ERROR } from '../../../../../data/assets/img';

import PageHeaderLoader from '../../../../../components/pageheader/loaders';
import CardRowTableLoader from '../../../components/loaders/cardrowtable';
import ProfileAvatar from '../../../../../components/profileavatar';
import TableCellAction from '../../../components/tablecellaction';
import CustomHeader from '../../../../../components/customheader';
import ModalFooter from '../../../../../components/modalfooter';
import ShowMessage from '../../../../../components/showmessage';
import AddTeamMember from './addteammember';

const team_member_type = [
    { name: 'All Members', value: 'all' },
    { name: 'Verified', value: 'isVerified' },
    { name: 'Active', value: 'isActive' },
    { name: 'Deleted', value: 'isDeleted' }
];

class TeamMemberSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: {
                search_text: "",
                granularity: "all"
            },
            drawer_data: {
                title: "Title",
                show_add_team_member: false,
            },
            filtered_team_members: props.team_member_setting_details.team_members,
            new_team_members: [],
        };
        this.columns = this.getTeamMembersTableColumns();
    }

    componentWillMount() {
        this.props.actions.pageChanged(APP_PAGES.TEAM_MEMBER_SETTING, APP_PAGES.SETTINGS);
    }

    componentDidMount() {
        this.props.actions.getAllTeamMembers();
    }

    componentWillReceiveProps(nextProps) {
        const { team_member_setting_details } = this.props;
        const { filter } = this.state;
        if (!isEqual(nextProps.team_member_setting_details.team_members.length, team_member_setting_details.team_members)) {
            const table_data = [...nextProps.team_member_setting_details.team_members];
            this.setState({
                filtered_team_members: this.filterTeamMembers(filter.search_text, table_data)
            });
        }
    }

    getTeamMembersTableColumns = () => {
        const { admin_details, isActionPermitted } = this.props;
        const is_update_allowed = isActionPermitted(PERMISSIONS.ACTIONS.TEAM_MANAGEMENT, PERMISSIONS.ACTION_TYPES.UPDATE);
        const columns = [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                render: (text, record) => {
                    return (
                        <ProfileAvatar container_class="ori-flex-ac" title={`${record.firstName} ${record.lastName}`} title_class="ori-font-sm ori-font-bold" default_avatar_bg={record.isDeleted} />
                    );
                }
            },
            {
                title: 'Email',
                dataIndex: 'email',
                key: 'email',
            },
            {
                title: 'Designation',
                dataIndex: 'designation',
                key: 'designation',
            },
            {
                title: 'Status',
                dataIndex: 'isVerified',
                key: 'isVerified',
                align: 'center',
                render: (text, record) => {
                    if (record.isDeleted) {
                        return (
                            <p className="ori-font-danger ori-text-center"><IconSuccess size={15} /> <span className="ori-lr-pad-3">DELETED</span></p>
                        )
                    } else if (record.isVerified) {
                        return (
                            <p className="ori-font-green ori-text-center"><IconSuccess size={15} /> <span className="ori-lr-pad-3">VERIFIED</span></p>
                        )
                    } else {
                        return (
                            <p className="ori-font-light ori-text-center"><IconHistory size={15} /> <span className="ori-lr-pad-3">PENDING</span></p>
                        )
                    }
                }
            },
            {
                title: 'Active',
                dataIndex: 'isActive',
                key: 'isActive',
                align: 'center',
                render: (text, record) => {
                    if (record.isVerified) {
                        return (
                            <div className="ori-flex-row ori-flex-jc">
                                <Switch size="small" checked={record.isActive} disabled={record.isDeleted || !is_update_allowed || record.psid === admin_details.admin_id} onChange={(bool) => this.changeMemberActivation(bool, record)} />
                            </div>
                        )
                    } else {
                        return null;
                    }
                }
            },
            {
                title: 'Action',
                dataIndex: 'action',
                key: 'action',
                align: 'center',
                render: (text, record) => {
                    if (!record.isDeleted) {
                        return (
                            <TableCellAction align_center show_setting show_delete handleSettingClick={() => this.handleMemberSetting(record)} handleDeleteClick={() => this.deleteTeamMember(record)} />
                        );
                    } else {
                        return null;
                    }
                }
            },
        ];
        return columns;
    };

    filterTeamMembers = (text, team_members) => {
        const { filter } = this.state;
        if (text.trim().length > 0) {
            if (filter.granularity === 'all') {
                return team_members.filter((member) => {
                    return (member.firstName && member.firstName !== undefined && member.firstName.toLowerCase().indexOf(text.toLowerCase()) !== -1);
                });
            } else {
                return team_members.filter((member) => {
                    return ((member.firstName && member.firstName !== undefined && member.firstName.toLowerCase().indexOf(text.toLowerCase()) !== -1) && (member[filter.granularity]));
                });
            }
        } else {
            if (filter.granularity === 'all') {
                return team_members;
            } else {
                return team_members.filter((member) => {
                    return member[filter.granularity];
                });
            }
        }
    };

    handleMemberSearch = (event) => {
        const search_text = event.target.value;
        const { team_member_setting_details } = this.props;

        this.setState({
            filter: { ...this.state.filter, search_text },
            filtered_team_members: this.filterTeamMembers(search_text, team_member_setting_details.team_members)
        });
    };

    handleGranularityChange = (e) => {
        const { filter } = this.state;
        const { team_member_setting_details } = this.props;
        const granularity = e.target.value;

        this.setState({ filter: { ...filter, granularity } }, () => {
            this.setState({ filtered_team_members: this.filterTeamMembers(filter.search_text, team_member_setting_details.team_members) })
        })
    };

    handleCloseDrawer = () => {
        this.setState({
            drawer_data: {
                title: "Title",
                show_add_team_member: false,
            },
            new_team_members: []
        });
    };

    showAddTeamMember = () => {
        const { isActionPermitted } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.TEAM_MANAGEMENT, PERMISSIONS.ACTION_TYPES.CREATE)) {
            this.setState({
                drawer_data: {
                    title: 'Add Team Members',
                    show_add_team_member: true,
                },
                new_team_members: [{}]
            });
        } else {
            showMessage('warning', 'you have not permission to add new team member.');
        }
    };

    updateComponentState = (payload, path) => {
        this.setState(dotProp.set(this.state, path, payload));
    };

    deleteComponentState = (path) => {
        this.setState(dotProp.delete(this.state, path));
    };

    inviteNewTeamMembers = () => {
        const { new_team_members } = this.state;
        const { actions } = this.props;
        const index = new_team_members.findIndex((member) => {
            if (member.email && member.firstName && member.lastName && member.email.trim().length > 0 && member.firstName.trim().length > 0 && member.lastName.trim().length > 0) {
                return false;
            } else {
                return true;
            }
        });
        if (index === -1) {
            const payload = {
                users: new_team_members,
                host: window.location.origin
            };
            actions.addNewMembers(payload, this.handleCloseDrawer);
        } else {
            showMessage('warning', 'please fill all the required field of each new member.');
        }
    }

    handleMemberSetting = (member) => {
        if (member && member.email && member.email.trim().length > 0) {
            const { history, match } = this.props;
            history.push(`${match.path}/${member._id}`);
        } else {
            showMessage('warning', 'user email is missing.');
        }
    };

    changeMemberActivation = (isActive, member) => {
        if (member && member.email && member._id) {
            const payload = {
                id: member._id,
                email: member.email,
                isActive,
            };
            this.props.actions.changeMemberActivation(payload);
        } else {
            showMessage('warning', 'user email/id is missing.');
        }
    };

    deleteTeamMember = (member) => {
        const { isActionPermitted, admin_details } = this.props;
        const is_other_account = member.psid && admin_details.admin_id !== member.psid;
        if (is_other_account) {
            if (isActionPermitted(PERMISSIONS.ACTIONS.TEAM_MANAGEMENT, PERMISSIONS.ACTION_TYPES.DELETE)) {
                if (member && member.email && member._id) {
                    const payload = {
                        id: member._id,
                        email: member.email,
                    };
                    this.props.actions.deleteTeamMember(payload);
                } else {
                    showMessage('warning', 'user email/id is missing.');
                }
            } else {
                showMessage('warning', "you have not permission to delete any team member.");
            }
        } else {
            showMessage('warning', "you can not delete your account yourself.");
        }
    };

    render() {
        const { page_details, team_member_setting_details } = this.props;
        const { drawer_data, new_team_members, filter, filtered_team_members } = this.state;
        const { screen_width } = this.props.page_details.device_data;

        if (team_member_setting_details.loaders.team_members_loading && !team_member_setting_details.loaders.team_members_loaded) {
            return (
                <div className="ori-pad-15">
                    <div className="ori-pad-40 ori-bg-white ori-box-shadow ori-border-radius-4">
                        <p className="ori-full-width ori-height-lg ori-card-loading">&nbsp;</p>
                    </div>
                    <PageHeaderLoader container_class="ori-lr-pad-10" bottom_bordered />
                    <CardRowTableLoader />
                </div>
            );
        } else if (!team_member_setting_details.loaders.team_members_loading && team_member_setting_details.loaders.team_members_loaded) {
            return (
                <div className="ori-lr-pad-15">
                    <CustomHeader title="team members" search_placeholder="Search team members" onChangeSearch={this.handleMemberSearch} granularity_options={team_member_type} granularity_value={filter.granularity} onChangeGranularity={this.handleGranularityChange} first_button_type="primary" first_button_text="+ Add Agent" onClickFirstButton={this.showAddTeamMember} bottom_bordered show_granularity show_search show_first_button />
                    <Table className="ori-card-row-table" rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light" scroll={{ x: 600 }} size={screen_width < 768 ? "small" : "middle"} pagination={{ pageSize: 20 }} rowKey={uniqueId} columns={this.columns} dataSource={filtered_team_members} />
                    <Drawer className="ori-drawer ori-drawer-title-primary" width={page_details.device_data.screen_width < 768 ? page_details.device_data.screen_width : 700} style={{ height: 'calc(100% - 60px)', overflow: 'hidden', padding: '0px 0px 62px 0px' }} title={drawer_data.title} visible={drawer_data.show_add_team_member} placement="right" maskClosable={false} onClose={this.handleCloseDrawer}>
                        {
                            drawer_data.show_add_team_member &&
                            <div className="ori-full-parent-height ori-overflow-auto ori-bg-default">
                                <AddTeamMember new_team_members={new_team_members} onChangeEmail={(value, index) => this.updateComponentState(value, `new_team_members.${index}.email`)} onChangeFirstName={(value, index) => this.updateComponentState(value, `new_team_members.${index}.firstName`)} onChangeLastName={(value, index) => this.updateComponentState(value, `new_team_members.${index}.lastName`)} onClickAddMember={() => this.updateComponentState({}, `new_team_members.${new_team_members.length}`)} onClickDeleteMember={(index) => this.deleteComponentState(`new_team_members.${index}`)} />
                                <div className="ori-absolute ori-full-width ori-align-bottom ori-align-left ori-b-pad-5">
                                    <ModalFooter capsule_button button_ok_text="invite" loading={team_member_setting_details.loaders.new_member_adding} handleCancelClick={this.handleCloseDrawer} handleOkClick={this.inviteNewTeamMembers} />
                                </div>
                            </div>
                        }
                    </Drawer>
                </div>
            );
        } else if (!team_member_setting_details.loaders.team_members_loading && !team_member_setting_details.loaders.team_members_loaded) {
            return (
                <ShowMessage img_src={IMG_ERROR} title="Error" message="unable to load team members list. please check your internet connection and reload the page." height={150} width={150} />
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        page_details: state.page_details,
        admin_details: state.admin_details,
        team_member_setting_details: state.team_member_setting_details,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, pageActions, teamMemberSettingActions), dispatch)
    };
}

TeamMemberSetting.propTypes = {
    actions: PropTypes.object,
    page_details: PropTypes.object,
    admin_details: PropTypes.object,
    team_member_setting_details: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    isActionPermitted: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(TeamMemberSetting);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/settings/teammembersetting/index.js